const SEARCH_BAR_PROPS = {
  size: 'small',
  variant: 'outlined',
  fullWidth: true,
};

export default SEARCH_BAR_PROPS;
